import { render, staticRenderFns } from "./TrendCommentManage.vue?vue&type=template&id=6f1fcbc4&scoped=true"
import script from "./TrendCommentManage.vue?vue&type=script&lang=js"
export * from "./TrendCommentManage.vue?vue&type=script&lang=js"
import style0 from "./TrendCommentManage.vue?vue&type=style&index=0&id=6f1fcbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1fcbc4",
  null
  
)

export default component.exports